import React, { useContext, useState } from "react";
import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { TeacherApi, TeacherDto } from "../../api-clients/api";
import { TextField } from "@fluentui/react";
import { getApiUrl } from "../../api-clients";
import { AppContext } from "../../contexts/AppContext";
import { SchoolContext } from "../../contexts/SchoolContext";
import FormButtons from "../Shared/FormButtons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
}));

interface IProps {
  teacherChanged?: () => void;
}
export default function CRUDTeacher({ teacherChanged }: IProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { openSnackbar } = useContext(AppContext);
  const { setTeacherUpdated } = useContext(SchoolContext);
  const [saving, setSaving] = useState<boolean>(false);
  const [teacherApi] = useState<TeacherApi>(new TeacherApi(getApiUrl()));
  const [applicationUserId, setApplicationUserId] = useState<string>("");

  const canSave: boolean = applicationUserId.trim().length > 0;

  const createTeacher = () => {
    if (!canSave) return;
    setSaving(true);
    teacherApi
      .create({
        applicationUserId: applicationUserId.trim(),
      } as TeacherDto)
      .then(() => {
        setSaving(false);
        setApplicationUserId("");
        openSnackbar(t("teachers.saveSuccess"), "success");
        setTeacherUpdated(true);
        if (teacherChanged) teacherChanged();
      })
      .catch(() => {
        setSaving(false);
        openSnackbar(t("common.errorOccurred"), "error");
      });
  };

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            required
            autoComplete="off"
            label={t("teachers.applicationUserId")}
            placeholder={t("teachers.applicationUserIdPlaceholder")}
            value={applicationUserId}
            onChange={(
              event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
              newValue?: string
            ) => setApplicationUserId(newValue ?? "")}
          />
        </Grid>
      </Grid>
      <div className={classes.wrapper}>
        <FormButtons
          onConfirmClick={createTeacher}
          disabled={saving || !canSave}
          cancelButtonVisible={false}
          confirmIcon="Add"
          confirmText={t("common.create")}
        />
        {saving && (
          <CircularProgress
            size={24}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: -12,
              marginLeft: -12,
            }}
          />
        )}
      </div>
    </div>
  );
}
